import React from 'react';
import { Button } from '@material-ui/core';
import LoginTheme from './login.styles';
import env from '../services/env';

const isDevelop = env('REACT_APP_DEVELOP');

const Login = (props) => {
    const classes = LoginTheme();
    const autenticar = () => {
        if (isDevelop === 'true') window.location.href = '/dashboard';
        else window.location.href = `${env('REACT_APP_BUNKER_API')}auth/monitor`;
    }

    return(
        <div className={classes.main}>
            <div className={classes.grid}>
                <img src="/assets/images/Bunker_branca.svg" alt="Alterdata Bunker" />
                <Button className={classes.button} onClick={() => autenticar()}>Entrar</Button>
            </div>
        </div>
    );
}

export default Login;
